import { connectToStores } from 'fluxible-addons-react';
import DocumentStore from '../../../../stores/DocumentStore';
import { SearchResult } from './SearchResult';
export default connectToStores(SearchResult, [DocumentStore], function (context, _a) {
    var url = _a.url;
    var doc = context.getStore(DocumentStore).getDocument(url);
    if (doc === null || doc === void 0 ? void 0 : doc.meta) {
        return {
            crumbs: doc.meta.breadcrumbs,
            description: doc.meta.description,
            url: doc.meta.url,
            isDocument: true,
        };
    }
    return {
        isDocument: false,
    };
});
